export const AUTH_TYPES = {
  API_KEY: "api_key",
  BASIC_AUTH: "basic_auth",
  BEARER: "bearer",
  OAUTH2_CLIENT_CREDENTIALS: "oauth2_client_credentials",
  MANUAL: "manual",
  OAUTH2_AUTH_CODE: "oauth2_auth_code",
} as const;

export const allowedTables = [
  { label: "Jobs", value: "recruitment_jobs" },
  { label: "Clients", value: "recruitment_clients" },
  { label: "Candidates", value: "recruitment_candidates" },
  { label: "Applications", value: "recruitment_applications" },
  { label: "Contacts", value: "contacts" },
  { label: "Users", value: "user_datasets" },
] as { label: string; value: string }[];

export const AutomationStatus = {
  RUNNING: "running",
  COMPLETED: "completed",
  FAILED: "failed",
  QUEUED: "queued",
  PAUSED: "paused",
  WAITING: "waiting",
} as const;
export type AutomationStatusType = (typeof AutomationStatus)[keyof typeof AutomationStatus];

export const MAX_SYNC_RECORD_EXPORT_RECORDS = 1_000_000;

export const allowedTablesSingular = () => {
  let tables = allowedTables.map((table) => {
    return { label: table.label.slice(0, -1), value: table.value };
  });
  return tables;
};

export const tableToSourceMap: Record<string, string> = {
  recruitment_jobs: "job",
  recruitment_candidates: "candidate",
  recruitment_clients: "client",
  recruitment_applications: "application",
  contacts: "contact",
  user_datasets: "user",
  access_groups: "access_group",
  recruitment_placements: "placement",
};

export function getModelRefFromEntityId(entityId: string): string {
  if (tableToSourceMap[entityId]) {
    return tableToSourceMap[entityId];
  }
  if (entityId.startsWith("custom:")) {
    return `ce:${entityId.slice(7)}`;
  }
  return entityId;
}

export type CustomEntityOption = {
  label: string;
  value: string;
  isCustomEntity?: boolean;
};
